// extracted by mini-css-extract-plugin
module.exports = {"qrCode":"QrCode_qrCode__3p13E","icon":"QrCode_icon__2iqzO"};